/**
 * Variant Content Toggler
 *
 * Shows/hides content based on the currently selected variant.
 * Elements with data-show-for-variant="variant-id" will only be shown
 * when that variant is selected.
 * Supports comma-separated list of variant IDs.
 */

class VariantContentToggler {
    constructor() {
        this.init();
    }

    init() {
        // Initial check on load
        this.updateVisibility(this.getCurrentVariantId());

        // Listen for variant changes
        document.addEventListener('variant:change', (event) => {
            if (event.detail && event.detail.variant) {
                this.updateVisibility(event.detail.variant.id);
            }
        });
    }

    getCurrentVariantId() {
        // 1. Try URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        
        if (variantId) {
            return parseInt(variantId);
        }

        // 2. Try finding the selected variant from the form input
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
            return parseInt(variantInput.value);
        }

        // 3. Fallback: Try to use the first available variant from the data-show-for-variant attributes
        // This acts as a smart default when no variant is explicitly selected (e.g. first load)
        const firstToggleElement = document.querySelector('[data-show-for-variant]');
        if (firstToggleElement) {
             const variants = firstToggleElement.getAttribute('data-show-for-variant').split(',');
             if (variants.length > 0) {
                 return parseInt(variants[0].trim());
             }
        }

        return null;
    }

    updateVisibility(currentVariantId) {
        if (!currentVariantId) return;

        const elements = document.querySelectorAll('[data-show-for-variant]');

        elements.forEach((element) => {
            const allowedVariants = element
                .getAttribute('data-show-for-variant')
                .split(',')
                .map((id) => parseInt(id.trim()));

            if (allowedVariants.includes(currentVariantId)) {
                element.classList.remove('hidden');
                element.style.display = ''; // fallback if hidden class isn't enough or overrides
            } else {
                element.classList.add('hidden');
                element.style.display = 'none'; // fallback
            }
        });
    }
}

// Initialize
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new VariantContentToggler());
} else {
    new VariantContentToggler();
}
